export enum COMBINED_TRACK_FILE_STATES {
  ERROR = 'error',
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete'
}
